/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  TextField,
  Paper,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { useEffect, useState } from "react";
import { getConfiguracion, saveConfiguracion } from "../../services/ConfiguracionService";
import Message from "../../utils/Message.jsx";
import WaitingDialog from "../../utils/WaitingDialog";

//
// ###########################################################################
//
const Configuracion = () => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const [valorDolar, setValorDolar] = useState(0);

  //
  // ################################################################################
  //
  useEffect(() => {
    loadConfiguracion();
  }, []);
  //
  // ################################################################################
  //
  const loadConfiguracion = async () => {

    setIsDoingSomething(true);
    const response = await getConfiguracion();
    setIsDoingSomething(false);

    if (response.ok) {
      setValorDolar(response.data.data[0].valor_dolar);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setValorDolar(e.target.value);
  };
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (valorDolar === "" || valorDolar < 0) {
      setMessage({
        messageText: "El valor de dólar ingresado no es válido",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    save();
  };
  //
  // ################################################################################
  //
  const save = async () => {

    const _item = {
      valor_dolar: +valorDolar,
    };

    setIsDoingSomething(true);
    const response = await saveConfiguracion(_item);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ p: 1 }}>
            <Grid container spacing={1}>

              <Grid item xs={12} sx={{ mt: 2, mb: 2 }}>
                <Typography variant="h5" display="block" gutterBottom>
                  Valor del Dólar
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={1} lg={1}>
                <TextField
                  id="valorDolar"
                  type="number"
                  label="Valor del Dólar"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    min: 1,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  name="valorDolar"
                  value={valorDolar}
                  variant="outlined"
                  onChange={handleChange}
                  autoFocus
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    onClick={handleSave}
                  >
                    Guardar
                  </Button>
                </Box>

              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Paper>

      {/* >>>> Messages */}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default Configuracion;
